import React, { useEffect, useState } from "react";
import HeadingSubHeading from "../../../../../components/ViewHeading/HeadingSubHeading";
import { Button, Card, Col, Dropdown, Flex, List, Row, Space, Typography } from "antd";
import { MasterConfigs } from "../../../../../interfaces/entity";
import FormSetup from "../../../../../components/Forms/FormSetup";
import { useDispatch } from "react-redux";
import { getData } from "../../../../../actions/apiCall";
import { MoreOutlined } from '@ant-design/icons'
import Configuration from "./Configurations";
const { Title, Text } = Typography
import './../../index.scss';

const WorkType = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [data, setData] = useState([])
    const [selectedWorkerType, setselectedWorkerType] = useState(null)
    const [workerId, setworkerId] = useState(null)
    const dispatch = useDispatch();

    useEffect(() => {
        getAllLeavePlans();
    }, [])

    useEffect(() => {
        if (workerId && selectedWorkerType?._id == workerId) {
            setIsOpen(true)
        }
    }, [workerId])

    const getAllLeavePlans = async () => {
        const resData = await dispatch(getData('/worker-type'))
        if (resData.code == 200) {
            if (resData.data.length > 0 && !selectedWorkerType) {
                setselectedWorkerType(resData.data[0])
            }
            setData(resData.data)
        }
    }

    const onClick = (item) => {
        setselectedWorkerType(item)
    }

    const formConfig: MasterConfigs = {
        modalTitle: () => 'Worker Type',
        api: () => '/worker-type',
        combo: [],
        getFormColumns: () => [
            {
                label: 'Worker Type Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Worker Type name' }]
            },
            {
                label: 'Short Code',
                name: 'shortCode',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Short Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 24,
            },
        ]
    }

    const onClose = () => {
        setworkerId(null)
        setIsOpen(false)
    }

    const renderListItem = (item) => {
        return <List.Item key={item.name} className={(selectedWorkerType?._id == item?._id ? 'active_list' : '') + " plan-item"} onClick={() => onClick(item)}>
            <Space direction="vertical" style={{ width: '100%' }}>
                <Title level={5}>{item?.name}</Title>
                <Text>{new Date(item?.createdAt).toDateString()}</Text>
            </Space>
        </List.Item >
    }

    return <>
        <FormSetup config={formConfig} open={isOpen} onClose={onClose} isModal={true} id={workerId} />
        <Flex justify="space-between">
            <HeadingSubHeading
                title="Worker Types"
                subTitle="Add, edit and manage worker types"
            />
            <Button type="primary" onClick={() => setIsOpen(true)}>Add Worker Type</Button>
        </Flex>
        <Row gutter={[16, 16]}>
            <Col span={4}>
                <Card
                    title="Worker Types"
                    className="custom-card"
                >
                    <List
                        bordered={false}
                        dataSource={data}
                        size="small"
                        renderItem={item => (renderListItem(item))}
                    />
                </Card>
            </Col>
            <Col span={20}>
                <Card>
                    <Space direction="vertical" style={{ width: '100%' }} size={[10, 10]}>
                        <Flex justify="space-between">
                            <Title level={5}>{selectedWorkerType?.name}</Title>
                            <Dropdown menu={{
                                items: [{
                                    key: '1',
                                    label: 'Edit',
                                }],
                                onClick: (e) => {
                                    setworkerId(selectedWorkerType?._id)
                                }
                            }}>
                                <Button icon={<MoreOutlined />} type="text" />
                            </Dropdown>
                        </Flex>
                        {selectedWorkerType && <Configuration key={selectedWorkerType._id} workerId={selectedWorkerType?._id} />}
                    </Space>
                </Card>
            </Col>
        </Row>
    </>
};

export default WorkType;